/* global Modal */
  
  if (!customElements.get('klaviyo-popup')) {   
    class KlaviyoPopUp extends HTMLElement {
        constructor() {
          super();
          this.fetch = null;
          this.fetchedUrls = [];
          this.klaviyoButtonMouseEnterHandler = this.handleKlaviyoButtonMouseEnter.bind(this);
          this.documentClickHandler = this.handleDocumentClick.bind(this);
          this.close = this.querySelector('.bis-close');
          this.productTitle = this.querySelector('.js-bis-title');
          this.variantTitle = this.querySelector('.js-bis-variant-title');
          this.variantId = this.querySelector('input[name="variant"]');
          this.submitBtn = this.querySelector('#bis-submit');
          this.chcekBox = this.querySelector('#bis-confirm');
          this.emailInput = this.querySelector('#bis-email');
          this.successAlert = this.querySelector('.bis-success');
          this.errorAlert = this.querySelector('.bis-error');

          document.addEventListener('click', this.documentClickHandler);
          this.addEventListener('click', this.handleCloseClick);
          this.submitBtn.addEventListener('click', this.handleSubmit.bind(this));
          this.chcekBox.addEventListener('change', this.handleCheckBox.bind(this));

          if (theme.device.hasHover && theme.mediaMatches.md) {
            document.querySelectorAll('.back-in-stock-button').forEach((button) => {
              this.bindKlaviyoButtonMouseEnter(button);
            });
           

          if ('MutationObserver' in window) {
            this.observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                // Add event listener to new buttons
                mutation.addedNodes.forEach((node) => {
                  if (node.nodeType === Node.ELEMENT_NODE) {
                    node.querySelectorAll('.back-in-stock-button').forEach((button) => {
                      this.bindKlaviyoButtonMouseEnter(button);
                    });
                  }
                });
  
                // Remove event listener from removed buttons
                mutation.removedNodes.forEach((node) => {
                  if (node.nodeType === Node.ELEMENT_NODE) {
                    node.querySelectorAll('.back-in-stock-button').forEach((button) => {
                      button.removeEventListener('mouseenter', this.klaviyoButtonMouseEnterHandler);
                    });
                  }
                });
              });
            });
  
            // Start observing changes to the DOM
            this.observer.observe(document.body, { childList: true, subtree: true });
          }
        }
      }

        disconnectedCallback(){
            document.removeEventListener('click', this.documentClickHandler);
            document.querySelectorAll('.back-in-stock-button').forEach((button) => {
              button.removeEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
            });
            if (this.observer) this.observer.disconnect();
          }

        /**
        * Bind a mouseenter event to a given quick add button if it's not already bound
        * @param {Element} button - The button element to bind the mouseenter event to.
        */
        bindKlaviyoButtonMouseEnter(button) {
            if (!button.dataset.quickPopupLoaded){
                button.dataset.quickPopupLoaded = 'true';
                button.addEventListener('mouseenter', this.klaviyoButtonMouseEnterHandler);
            }
        }

         /**
        * Start the fetch on hover of a quick add button for perceived performance gains
        * @param {object} evt - Event object.
        */
        handleKlaviyoButtonMouseEnter(evt) {
           console.log(evt.target.dataset.product);
        }

        handleDocumentClick(evt){
            if (!evt.target.matches('.back-in-stock-button')) return;
            this.style.display = "block";
            this.productTitle.textContent = evt.target.dataset.product;
            this.variantTitle.textContent = evt.target.dataset.variant;
            this.variantId.value = evt.target.dataset.vid;
        }

        handleCloseClick(evt){
           if(!evt.target.matches('.bis-close')) return;
           this.style.display = "none";
        }
        handleCheckBox(evt){
          if(!evt.target.matches('#bis-confirm')) return;

          if(this.chcekBox.checked){
            this.submitBtn.disabled = false;
          }else{
            this.submitBtn.disabled = true;
          }
        }

        handleSubmit(evt){
          if(!evt.target.matches('#bis-submit')) return;

          const payload = JSON.stringify({
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                profile: {
                  data: {
                      type: "profile",
                      attributes: {
                          email: `${this.emailInput.value}`,
                      }
                  }
                },
                channels: ["EMAIL"],
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: `$shopify:::$default:::${this.variantId.value}`
                  }
                }
              }
            }
          });

          

          let requestOptions = {
            method: 'POST',
            headers: {"Content-Type": "application/json", "revision": "2023-10-15", "Authorization": "pk_64959439ad9b43cc0b7352da49ea800157", 'Access-Control-Allow-Origin':'*'},
            mode: 'cors',
            body: payload
          }

          let companyId = "iUWEFA";
          const store = Shopify.shop.split(".myshopify")[0];
          if(store === "umbra-ca"){
            companyId = "KiLPmu"
          }else if(store === "umbra-eu"){
            companyId = "Pu3mAK"
          }else if(store === "umbra-uk"){
            companyId = "JiqHEq"
          }else{
            
          }

          fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${companyId}`, requestOptions)
            .then(response => console.log(response))
            .then(result => {
                 if(this.successAlert){
                  setTimeout(() => {
                    this.successAlert.hidden = false
                  }, 1000)

                  setTimeout(() => {
                    this.successAlert.hidden = true
                  }, this.successAlert.dataset.visibleFor)
                 }
            })
            .catch(error => {
              if(this.errorAlert){
                setTimeout(() => {
                  this.errorAlert.hidden = true
                }, 1000)

                setTimeout(() => {
                  this.errorAlert.hidden = false
                }, this.errorAlert.dataset.visibleFor)
              }
            });

        }
  
        /**
         * Triggers when the web component is removed from the DOM
         */
        disconnectedCallback() {
          if (this.mouseLeaveHandler) {
            document.body.removeEventListener('mouseleave', this.mouseLeaveHandler);
          }
  
          if (this.copyHandler) {
            document.removeEventListener('copy', this.copyHandler);
          }
        }
  
        /**
         * Handles 'mouseleave' events on the body.
         * @param {object} evt - Event object.
         */
        handleMouseLeave(evt) {
          if (evt.clientY < 0 && !getCookie(this.cookie)) this.open();
        }
  
        /**
         * Handles 'close' events on the modal.
         */
        close() {
          super.close();
        }
      }
  
      customElements.define('klaviyo-popup', KlaviyoPopUp);
  }
  